//
// to create a GameBaseSetup ,  contains general variables and list of images to load to starts the game
// import dataGC from  "../../rendpandaGameContexts/RedPandaStudio-GameContexts-1.0.0-domain";
import * as Sentry from "@sentry/browser";
import { polyfill } from "es6-promise";
import { getParameterByName } from "../../getParameters";
import { GameAssetsLoader } from "../GameLoader/gameFilesLoader";
// import { API_Abs } from '../api_Abstraction';
import { AnimationFrameRate } from "../animationFrameRate";
import {
  autoRescale,
  playerActivityUpdate,
  pauzeAutoPlayOnOrientationChange,
  onOptionButtonDownRedirectHome,
} from "../../functions/Functions_General";

import * as tweenManager from "k8w-pixi-tween";
console.log(
  tweenManager != undefined
    ? "Tween plugin loaded"
    : "Error loading tween plugin"
);
import { PopupMessageBox } from "../../messageBox";
import { Credits } from "../../datastructures/Credits";
// import { freeSpinsMessageCheck } from '../FreeSpin/freeSpinFunctions';
import { GameBar } from "../gameUIBar/gameBar";
import { ClockDisplay } from "../clock";
import { jackPotManager } from "../../JackpotGame/jackPotManager";
// import { MobileGuideDisplayManager } from "../slideToFullScreen";
import { GambleGame } from "../GambleGame/gambleGame";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { AutoplayPopper } from "../autoplayPopper";
import { BetPopper } from "../betPopper";
import {
  betConfirm,
  onChangeAutoplay,
  onBetChangeWindow,
  setAutoPlay,
  checkUserBalToBet,
  gambleClick,
  enableChangeBet,
  lowBalConfirm,
  depositURL,
  onBetChangeUpdateMinimumStakePopup,
} from "../../functions/Functions_GameBar";

import { OptionBuilder } from "../Option/OptionBuilder";
import { FreespinMode } from "../FreeSpin/freeSpinModeMain";
import { checkCookie, generateVersion } from "../../functions/cookies";
import { Backgroundsky } from "../bg_sky";
import { JumpingCoins } from "../JumpingCoin/jumpingCoinMain";
import {
  musicSelect,
  setDynamicRenderResolution,
  toggleFullScreenOption,
} from "../../functions/Function_settingsPage";
import { logoOverlay } from "../overlayLogo";
import { IGameElement } from "./GameElement";
import { Replay } from "../Replay/replayMain";
import { WinAnimation } from "../winAnimation/winAnimationBuilder";
import { PortraitMode } from "../PortraitMode/portraitPlayUi";
import { Tournament } from "../Tournament/Main_Tournament";
import { debuggerScreenSize } from "../screenSizeDebugger";
import { portraitBGCommon } from "../PortraitMode/portraitModeBg";
import { Howler } from "howler";
import { blackScreenCover } from "../blackScreenCover";
import { GambleGameNico } from "../GambleGameNico/gambleGameNico";
import { EmulationMain } from "../Replay/emulation/emulationMain";
import { AlwaysVisibleGameBlackBar } from "../Addons/blackBarBottomScreenLandscape/alwaysVisibleGameNameDisplayer";
import { configureAndInitilizeSentry } from "./SentrySetup/sentryInit";
import { starLog } from "../../functions/helper.ts/logger";
polyfill();

export class GameBaseSetup<T extends CommonData> {
  private app: PIXI.Application;
  private lang: string;
  private API_Handler: any;
  private gameContainer: PIXI.Container;
  private activeGameData: CommonData;
  private gameLoader: GameAssetsLoader;
  private loginData: any;
  private setup: Function;
  // private mobileGuideDisplay: MobileGuideDisplayManager;
  private mobilePortraitBG: PIXI.Sprite;

  private c_portraitBG: PIXI.Container;
  // private black: splashScreen;
  private c_bg: PIXI.Container;
  private c_env: PIXI.Container;
  private c_gameSceneBG: PIXI.Container;
  private c_logoContainer: PIXI.Container;
  private c_gameScene: PIXI.Container; //default game Container
  private c_BonusGame: PIXI.Container;
  private c_containerOverGameScene: PIXI.Container;
  private c_gameBar: PIXI.Container;
  private c_blackScreenContainerBuyBonus: PIXI.Container; //--fluide
  private c_JackpotGame: PIXI.Container;
  private c_coins: PIXI.Container;
  private c_bonusBuy: PIXI.Container;
  private c_blackScreenContainer: PIXI.Container; //--fluide
  private c_bonusOverMessageContainerBG: PIXI.Container; //--fluide
  private overlayBonusContainer: PIXI.Container = new PIXI.Container();
  private c_bonusOverMessageContainer: PIXI.Container; //with clipping
  private c_bonusOverMessageContainerNoClipping: PIXI.Container; //with no clipping
  private c_tournament: PIXI.Container;
  private c_option: PIXI.Container;
  private c_floatingBtn: PIXI.Container;
  private c_mobilePortrait: PIXI.Container;
  private c_replay: PIXI.Container;
  private c_miniumBetReminder: PIXI.Container = new PIXI.Container(); //fixed
  private c_all: Array<PIXI.Container>;
  private c_MASK: PIXI.Graphics;

  private c_gameNameWaterMarkLandScape = new PIXI.Container();
  private c_gameNameWaterMarkPortrait = new PIXI.Container();
  private debuggerScreen: debuggerScreenSize;
  private portraitModeBackground: portraitBGCommon;

  constructor(
    gameData: CommonData,
    assettoLoad: Array<Array<string>>,
    fnSetup: Function
  ) {
    configureAndInitilizeSentry();
    preserveDrawingBuffer: true;
    PIXI.glCore.VertexArrayObject.FORCE_NATIVE = true;
    PIXI.settings.RENDER_OPTIONS.clearBeforeRender = true;
    PIXI.settings.RENDER_OPTIONS.legacy = true;
    //by default load the game on webgl and on fail autoload with canavas
    this.app = new PIXI.Application({
      width: window.innerWidth,
      height: window.innerHeight,
      transparent: false,
      antialias: false,
      // forceCanvas: this.useCanvas()
    });
    this.app.renderer.clearBeforeRender = true;
    document.body.appendChild(this.app.view);
    this.activeGameData = gameData;

    this.gameLoader = new GameAssetsLoader(
      this.app.stage,
      this.activeGameData.brandLogoIndex,
      assettoLoad
    );
    this.gameLoader.setLoginFn(this.loginFn.bind(this));
    // this.gameLoader.startLoad();

    // this.API_Handler = new API_Abs(gameData.gameId);
    // this.activeGameData = gameData;

    this.API_Handler = this.activeGameData.API_handler;
    // console.log( this.activeGameData.API_handler)
    this.activeGameData.app = this.app;
    this.activeGameData.size = [1920, 1080];
    this.activeGameData.stage = this.app.stage;
    this.activeGameData.ratio =
      this.activeGameData.size[0] / this.activeGameData.size[1];
    this.defineResolution();
    this.activeGameData.gameScene = new PIXI.Container();
    this.gameContainer = new PIXI.Container(); //eveything that on background taht need to be scaled to anysize

    // this.c_portraitOutFrame=new PIXI.Container();
    this.c_portraitBG = new PIXI.Container();
    this.c_bg = new PIXI.Container(); //scalable bg elements ex:sky
    this.c_env = new PIXI.Container(); //fixed bg elements,
    this.c_gameSceneBG = new PIXI.Container();
    this.c_logoContainer = new PIXI.Container();

    this.c_gameScene = new PIXI.Container(); //fixed ,mains game and set
    this.c_BonusGame = new PIXI.Container(); //fixed
    this.c_containerOverGameScene = new PIXI.Container(); //fixed

    this.c_gameBar = new PIXI.Container();
    this.c_blackScreenContainerBuyBonus = new PIXI.Container(); //fixed
    this.c_JackpotGame = new PIXI.Container(); //fixed
    this.c_coins = new PIXI.Container(); //fixed
    this.c_bonusBuy = new PIXI.Container(); //fixed

    this.activeGameData.coinsContainer = this.c_coins;
    this.activeGameData.bonusBuyContainer = this.c_bonusBuy;

    this.c_blackScreenContainer = new PIXI.Container(); //fixed
    this.c_bonusOverMessageContainerBG = new PIXI.Container(); //fixed

    this.c_bonusOverMessageContainer = new PIXI.Container(); //fixed

    this.c_bonusOverMessageContainerNoClipping = new PIXI.Container(); //fixed
    this.c_gameNameWaterMarkLandScape = new PIXI.Container(); //game name,
    this.c_gameNameWaterMarkPortrait = new PIXI.Container(); //game name,
    //-black overlay

    this.activeGameData.blackScreen = new blackScreenCover(
      this.c_blackScreenContainer
    );
    this.activeGameData.blackScreen2 = new blackScreenCover(
      this.c_blackScreenContainer
    );
    this.activeGameData.blackScreen_buyIn = new blackScreenCover(
      this.c_blackScreenContainerBuyBonus
    );

    this.c_tournament = new PIXI.Container(); //fixed
    this.c_option = new PIXI.Container(); //fixed
    this.c_floatingBtn = new PIXI.Container(); //scalable;
    this.c_mobilePortrait = new PIXI.Container(); //scalable;
    this.c_replay = new PIXI.Container(); //scalable;

    this.c_all = [
      this.c_env,
      this.c_gameSceneBG,
      this.c_gameScene,
      this.c_BonusGame,

      this.c_gameBar,
      this.c_JackpotGame,
      this.c_coins,
      this.c_bonusBuy,
      // this.c_bonusOverMessageContainerBG,
      this.overlayBonusContainer,
      this.c_bonusOverMessageContainer,
      this.c_bonusOverMessageContainerNoClipping,
      this.c_tournament,
      this.c_option,
      this.c_floatingBtn,
      this.c_mobilePortrait,
      this.c_replay,
      this.c_miniumBetReminder,
      //-always on top
      this.c_gameNameWaterMarkLandScape,
      this.c_gameNameWaterMarkPortrait,
    ];

    this.setActiveGameDataDefaults(gameData);
    // this.app.stage.addChild(this.gameContainer);
    this.activeGameData.renderFrameRate = new AnimationFrameRate(this.app);
    // this.gameContainer.addChild(this.activeGameData.gameScene);
    window.addEventListener(
      "resize",
      this.preloadProgressResize.bind(this),
      false
    );
    this.preloadProgressResize(); //first rescale to fit
    this.setup = fnSetup;
  }

  private updateAudioOnTabVisibilityChange = (): void => {
    const isManuallyMuted = this.activeGameData.isAudioMuted;
    const isTabVisible = document.visibilityState === "visible";

    if (!isManuallyMuted && isTabVisible) {
      // Unmute only if user didn't manually mute, and tab is visible
      Howler.mute(false);
      starLog("-----Audio unmuted");
    } else {
      // Otherwise, always mute
      Howler.mute(true);
      starLog("-----Audio muted");
    }
  };

  private setListeners = (): void => {
    // 🔄 Handle screen orientation changes
    window.addEventListener(
      "orientationchange",
      () => this.setRescale(),
      false
    );

    // 🔄 Handle window resize (desktop or mobile)
    window.addEventListener("resize", () => this.setRescale(), false);

    // 🎧 Function to resume the audio context if suspended (common on iOS Safari)
    const resumeAudioContext = () => {
      const ctx = Howler.ctx;
      if (ctx && ctx.state === "suspended") {
        ctx.resume().catch((err) => {
          console.warn("Failed to resume audio context:", err);
        });
      }
    };

    // 👆 Resume audio on first user interaction (important for iOS autoplay policies)
    document.addEventListener("touchstart", resumeAudioContext, { once: true });
    document.addEventListener("click", resumeAudioContext, { once: true });

    // 👁️ When user returns to the tab, unmute or resume audio context
    document.addEventListener("visibilitychange", () => {
      this.updateAudioOnTabVisibilityChange(); // Custom app logic (mute/unmute)
      if (document.visibilityState === "visible") {
        resumeAudioContext(); // Resume Howler's audio context if suspended
      }
    });
    window.addEventListener("blur", () => {
      this.updateAudioOnTabVisibilityChange();
    });

    window.addEventListener("focus", () => {
      this.updateAudioOnTabVisibilityChange();
    });
    // ⌨️ Handle keyboard input for desktop users (e.g., accessibility, cheat codes, etc.)
    document.addEventListener("keydown", (key: KeyboardEvent) => {
      this.activeGameData.keyPress(key, this.activeGameData);
    });

    // 🎮 Get the game's canvas element (required for touch and click interactions)
    const canvas = document.getElementsByTagName("canvas")[0];

    if (canvas) {
      // 📱 iOS touch/click interaction to play silent/null sound to unlock audio
      canvas.addEventListener("touchend", () => {
        this.activeGameData.firstNullAudio.playAudio(); // Typically a silent sound
      });

      canvas.addEventListener("click", () => {
        this.activeGameData.firstNullAudio.playAudio();
      });

      // 🔲 On non-iPhone devices, try entering fullscreen when canvas is tapped
      if (!this.activeGameData.isIphone) {
        canvas.addEventListener("touchend", () => {
          if (!document.fullscreenElement) {
            toggleFullScreenOption(this.activeGameData);
          }
        });
      }
    } else {
      // 🚨 Fallback if canvas not found (fail-safe logging)
      console.warn("Canvas element not found!");
    }
  };

  // private iPhoneFSCheck=():void=>
  // {
  //     this.mobileGuideDisplay.checkFullScreenIphone();
  // }
  private placeContainersOrder = (): void => {
    this.portraitModeBackground = new portraitBGCommon(
      this.activeGameData,
      this.c_portraitBG
    );
    this.activeGameData.PortraitUiContainer = this.c_portraitBG;
    this.gameContainer.addChild(this.c_portraitBG); //bg of portrait element
    this.gameContainer.addChild(this.c_bg); //--large static BG
    this.gameContainer.addChild(this.c_env); //--smaller bg that can also contains animated stuffs

    this.gameContainer.addChild(this.c_gameSceneBG); //gamecontainer
    this.gameContainer.addChild(this.c_gameScene); //gamecontainer
    this.gameContainer.addChild(this.c_BonusGame); //

    this.gameContainer.addChild(this.c_containerOverGameScene); //
    // this.gameContainer.addChild(this.c_bonusBuy)
    this.gameContainer.addChild(this.c_gameBar);

    this.gameContainer.addChild(this.c_floatingBtn);
    // this.gameContainer.addChild(this.c_option);
    this.gameContainer.addChild(this.c_mobilePortrait);

    this.gameContainer.addChild(this.c_blackScreenContainerBuyBonus);
    this.gameContainer.addChild(this.c_bonusBuy);
    this.gameContainer.addChild(this.c_blackScreenContainer);
    this.gameContainer.addChild(this.c_bonusOverMessageContainerBG);
    this.gameContainer.addChild(this.overlayBonusContainer);
    this.gameContainer.addChild(this.c_bonusOverMessageContainer);
    this.gameContainer.addChild(this.c_bonusOverMessageContainerNoClipping);

    this.gameContainer.addChild(this.c_JackpotGame); //-jackpot layer on very top
    this.gameContainer.addChild(this.c_coins);
    this.gameContainer.addChild(this.c_miniumBetReminder); //logo on top of the game

    this.activeGameData.blackScreenParent = this.c_blackScreenContainer;
    this.activeGameData.messageBGContainer = this.c_bonusOverMessageContainerBG;
    this.activeGameData.overlayBonusContainer = this.overlayBonusContainer;
    this.activeGameData.messageContainer = this.c_bonusOverMessageContainer;
    this.activeGameData.messageContainerNoClipping = this.c_bonusOverMessageContainerNoClipping;

    this.gameContainer.addChild(this.c_replay);
    this.gameContainer.addChild(this.c_tournament);
    this.gameContainer.addChild(this.c_option);

    this.activeGameData.gameScene = this.c_gameScene; //used to place
    this.activeGameData.replay = new Replay(this.c_replay, this.activeGameData);
    ///--on very top
    this.addGameNameOverlay();

    ///check if emulation
    let gamemode = getParameterByName("mode").toLowerCase();
    if (gamemode == "emulation") {
      this.activeGameData.isEmulation = true;
    }

    if (this.activeGameData.isEmulation) {
      this.activeGameData.emulationMode = new EmulationMain(
        this.c_replay,
        this.activeGameData
      );
    }

    this.activeGameData.addMinimumStakePopupTo(this.c_miniumBetReminder);

    //--make a copy to commonData
    this.activeGameData.portraitModeBackground = this.portraitModeBackground;
    this.activeGameData.bgGradient = this.c_bg;
    this.activeGameData.bgEnv = this.c_env;
    this.activeGameData.gameSceneBG = this.c_gameSceneBG;
    this.activeGameData.gameSceneBonus = this.c_BonusGame;

    // this.test= new PIXI.Graphics;

    this.activeGameData.winAnimation = new WinAnimation(
      this.c_coins,
      this.activeGameData.size,
      this.activeGameData.gameVersion,
      this.activeGameData,
      true
    );

    this.activeGameData.soundList.push(
      this.activeGameData.winAnimation.getAudioCoin()
    );
    this.activeGameData.soundList.push(
      this.activeGameData.winAnimation.getAudioHit()
    );
    this.activeGameData.soundList.push(
      this.activeGameData.winAnimation.getAudioTension()
    );

    //-add debugger
    this.debuggerScreen = new debuggerScreenSize(this.gameContainer);
  };

  private addGameNameOverlay = (): void => {
    ///--on very top
    this.gameContainer.addChild(this.c_gameNameWaterMarkLandScape);
    this.gameContainer.addChild(this.c_gameNameWaterMarkPortrait);
    if (!this.activeGameData.miniBlackBarLandscape) {
      this.activeGameData.miniBlackBarLandscape = new AlwaysVisibleGameBlackBar(
        this.activeGameData
      );
    }

    this.activeGameData.miniBlackBarLandscape.setParents(
      this.c_gameNameWaterMarkLandScape,
      this.c_gameNameWaterMarkPortrait
    );
    // this.c_gameNameWaterMark.addChild(
    //   this.activeGameData.miniBlackBarLandscape
    // );
    this.activeGameData.miniBlackBarLandscape.updateGameNameText(
      this.activeGameData.gameName
    );
    let gameMode = getParameterByName("mode").toUpperCase();
    this.activeGameData.miniBlackBarLandscape.updateGameModeText(gameMode);
  };

  private defineResolution = () => {
    if (window.innerWidth / window.innerHeight >= this.activeGameData.ratio) {
      this.activeGameData.resolution =
        window.innerHeight / this.activeGameData.size[1];
    } else {
      this.activeGameData.resolution =
        window.innerWidth / this.activeGameData.size[0];
    }
  };
  private setActiveGameDataDefaults(gameData: CommonData) {
    this.activeGameData = gameData;
    if (this.activeGameData.enableMobileMode) {
      this.activeGameData.isMobile = getParameterByName("mobile") == "true";
    } else {
      this.activeGameData.isMobile = false;
    }
    this.activeGameData.gameVersion = generateVersion();
    this.activeGameData.lang = getParameterByName("lang").toLowerCase();
    this.activeGameData.gameId = this.API_Handler.getGameId();
    this.activeGameData.brand = this.API_Handler.getBrand();
    this.activeGameData.endpoint = this.API_Handler.getEndPoint();
    this.activeGameData.token = this.API_Handler.getToken();
    this.activeGameData.isIphone =
      !!navigator.platform && /iPhone|iPod/.test(navigator.platform);
    // this.activeGameData.API_handler = this.API_Handler;
    this.activeGameData.callBackFailMessage = this.callBackFailMessage.bind(
      this
    );
    this.activeGameData.gameResize = this.setRescale;
    this.activeGameData.background = new Backgroundsky(this.c_bg, this.app);
    this.setMask();
  }

  private async loginFn() {
    try {
      await this.setLang();
      this.placeContainersOrder();

      const tournamentID = getParameterByName("tournamentId");
      const gameMode = getParameterByName("mode");

      this.loginData = {
        operator: this.activeGameData.API_handler.getBrand(),
        gameReference: this.activeGameData.gameId,
        tournamentId: tournamentID,
        gameMode: gameMode,
      };

      // Await the wrapped login result, which returns a promise
      const loginResult = await this.getLoginResultAsync(this.loginData);
      // Call your success callback with the result
      this.loginSuccessCallBack(loginResult);
      // Set up listeners after successful login
      this.setListeners();
    } catch (e) {
      console.error("loginFn failed:", e);
      Sentry.captureException(e);

      this.loginFail(e);
    }
  }

  private getLoginResultAsync(loginData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.API_Handler.GetLoginResult(
        loginData,
        (result: any) => resolve(result), // on success
        (error: any) => reject(error) // on fail
      );
    });
  }

  private async setLang(): Promise<void> {
    const resources = this.gameLoader.gameFileLoader.resources;

    // Define exact keys we expect in the resources object
    type ResourceKey = keyof typeof resources;
    type DataField = { data: any };

    const ensureResource = async (
      key: ResourceKey,
      label: string
    ): Promise<void> => {
      const resource = resources[key] as DataField | undefined;
      if (!resource?.data) {
        const errorMessage = `Critical: ${label} is missing. Execution halted.`;
        console.error(errorMessage);
        await Sentry.captureException(new Error(errorMessage));
        throw new Error(errorMessage);
      }
    };

    const assignWithFallback = <T extends keyof typeof this.activeGameData>(
      mainKey: ResourceKey,
      defaultKey: ResourceKey,
      targetField: T,
      warningMessage: string
    ): void => {
      const mainRes = resources[mainKey] as DataField | undefined;
      const defaultRes = resources[defaultKey] as DataField;

      if (!mainRes?.data) {
        console.warn(warningMessage);
        this.activeGameData[targetField] = defaultRes.data;
      } else {
        this.activeGameData[targetField] = mainRes.data;
      }
    };

    // Ensure critical defaults exist
    await ensureResource("langDefault", "Default language file");
    await ensureResource("langGeneralDefault", "General default language file");
    await ensureResource(
      "tournamentDefaultTextFile",
      "Default tournament language file"
    );

    // Assign language resources with fallback
    assignWithFallback(
      "lang",
      "langDefault",
      "gameText",
      "Text file in selected language doesn't exist. Defaulting to English."
    );

    assignWithFallback(
      "langGeneral",
      "langGeneralDefault",
      "gameTextGeneral",
      "General text file in selected language doesn't exist. Defaulting to English."
    );

    assignWithFallback(
      "tournamentTextFile",
      "tournamentDefaultTextFile",
      "tournamentText",
      "Tournament text file in selected language doesn't exist. Defaulting to English."
    );

    // Final setup
    this.activeGameData.getGameLoaderRessources = this.getGameLoaderRessources;
    this.activeGameData.checkMarket();
  }

  public getGameLoaderRessources = (): PIXI.loaders.ResourceDictionary => {
    return this.gameLoader.gameFileLoader.resources;
  };
  private preloadProgressResize = (): void => {
    autoRescale(this.gameLoader.getParent(), this.activeGameData, this.app);
  };

  private loginSuccessCallBack = (data: any): void => {
    if (this.activeGameData.API_handler.getInitUrl != undefined) {
      this.activeGameData.initUrl = this.activeGameData.API_handler.getInitUrl();
    }

    //-
    this.activeGameData.gameLoaded = true; //game has finished loading and successfully logged in
    this.activeGameData.loginResponse = data;

    if (this.activeGameData.loginResponse.gameSettings.payTable != undefined) {
      let payTable = this.activeGameData.loginResponse.gameSettings.payTable;
      this.activeGameData.gamePayTableValues = new this.activeGameData.GamePayTableBuilder(
        payTable
      );
    }

    // console.log(
    //   "LOGIN REPONSE",
    //   this.activeGameData.loginResponse.gameSettings.defaultStake
    // );

    this.activeGameData.homeURl = getParameterByName("homeUrl");
    this.API_Handler.setToken(data.token);

    this.activeGameData.balance = new Credits(
      data.playerBalance.creditsBalance.amount
    );
    //update also the player balnce on betReponseData;
    this.activeGameData.betResponse.playerBalance.creditsBalance.amount = this.activeGameData.balance.getServerVal();

    this.activeGameData.betList = [];

    // var stakes = JSON.parse(data.gameSettings).stakes
    var stakes = data.gameSettings.stakes;
    for (var i = 0; i < stakes.length; i++) {
      // console.log
      // this.activeGameData.betList.push(new Credits((JSON.parse(data.gameSettings).stakes[i])));
      this.activeGameData.betList.push(new Credits(stakes[i]));
    }

    this.activeGameData.betSelected = this.activeGameData.betList[
      this.activeGameData.betIndex
    ]; //-by default take the third index
    if (
      this.activeGameData.loginResponse.gameSettings.defaultStake != undefined
    ) {
      let defaultGiven = this.activeGameData.loginResponse.gameSettings
        .defaultStake;

      let listStake = this.activeGameData.loginResponse.gameSettings.stakes;

      this.activeGameData.betIndex = listStake.indexOf(defaultGiven);
      this.activeGameData.betSelected = this.activeGameData.betList[
        this.activeGameData.betIndex
      ];
      // console.log("d", this.activeGameData.betSelected.getServerVal())
      //- update the default stake selected from the server
      this.activeGameData.betResponse.gameContext.contextData.stake.amount = this.activeGameData.betSelected.getServerVal();
    }
    this.activeGameData.jackpotsId = data.jackpot_ids;
    this.destroyLoadingScreenListner();

    try {
      this.postLogin(data);
      onBetChangeUpdateMinimumStakePopup(this.activeGameData);
    } catch (error) {
      console.log(error);
      Sentry.captureException(error);
    }

    // this.createGameRoundDisplayer();
  };
  // private createGameRoundDisplayer = (): void => {
  //   return;
  //   console.log(
  //     "this.activeGameData.miniBlackBarLandscape",
  //     this.activeGameData.miniBlackBarLandscape
  //   );
  //   this.activeGameData.gameRoundDisplayOverlay = new GameRoundDisplay(
  //     this.c_option,
  //     this.activeGameData.gameTextStyle.gameFont
  //   );
  //   this.setRescale(); //call rescale so that the  position are updated correctly wafter setup;
  // };

  private postLogin(data: any) {
    let gamemode = getParameterByName("mode").toLowerCase();

    if (gamemode == "demo") {
      this.activeGameData.isDemo = true; //default false
    }

    if (gamemode == "replay") {
      this.activeGameData.InspectReplay = true; //default false
    }

    if (gamemode == "tournament") {
      this.activeGameData.isTournament = true;
    }
    if (gamemode == "emulation") {
      this.activeGameData.isEmulation = true;
    }

    // this.activeGameData.isTournament = true;//test and also disable the requeServerForScore inside tournament main to test
    //define game currency
    this.activeGameData.currency = this.activeGameData.loginResponse.playerBalance.creditsBalance.currency; //define game currency;
    if (this.activeGameData.isTournament) {
      this.activeGameData.currency = "";
      this.activeGameData.currencyPurchases = this.activeGameData.loginResponse.playerBalance.creditsBalance.currency;
    }

    // this.activeGameData.winAnimation.setCurrency();

    this.createCoins();
    this.createJackpot();
    this.createTournament();
    this.activeGameData.defineFunctions();
    this.setup();
    checkCookie(this.activeGameData); //--check cookies and  load setings;
    musicSelect(0, this.activeGameData);
    this.setFreeSpins(); //Create Free Spins Mode

    this.activeGameData.freeSpinMode.setMessageDisplay();

    // reload a previous game if its active
    if (data.activeGame) {
      this.activeGameData.reloadGame = true;
      this.activeGameData.betResponse.gameContext.contextData.finished = false;
      this.recoverGame();
    }

    //---

    enableChangeBet(true, this.activeGameData); //set bet true by default

    // this.activeGameData.playBaseGameMusic(true);
    checkUserBalToBet(this.activeGameData);

    if (this.activeGameData.isTournament) {
      // autoPopup the  tournament windows when starting the game

      //open register page if balance is zero

      if (
        this.activeGameData.loginResponse.playerBalance.creditsBalance
          .amount === 0
      ) {
        this.activeGameData.tournamentmode.goToSelectedPage(3); //default load welcome page;
      } else {
        this.activeGameData.tournamentmode.goToSelectedPage(0); //default load welcome page;
      }
    }

    //--create sticker for portrait mode
    if (this.activeGameData.isDemo) {
      this.portraitModeBackground.createDemoStickerPortrait();
    }
    // **--
    // console.log("www")
    //----create the bonus game splash
    // this.activeGameData.blackScreen = new blackScreenCover(
    //   this.c_bonusOverMessageContainerBG
    // );
    // this.activeGameData.blackScreen2 = new blackScreenCover(
    //   this.
    // );

    //   this.c_bonusOverMessageContainer,this.c_bonusOverMessageContainerBG,
    //   this.activeGameData
    // );

    // console.log("closess")

    //---test
    // this.callBackFailMessage(6)
    //  this.activeGameData.winAnimation.displayWin(10000,10);
    // let test= new PopupMessageBox(2,[10,10],this.activeGameData)

    // test.setHeadText("CONGRATS !!");
    // test.setBodyText("YOU WON SOMETHING!");
    // test.setBodyText2("200 EUR!");

    // let a=function(){console.log("CLICK")};
    // test.setBtns(2,["CKICK A","CLICK B"],[a,a]);
    // test.setMessageBoxVisibile(true,1)
  }
  private createMenuBar = (
    floatingParent: PIXI.Container,
    playerActivityUpdate: Function
  ): void => {
    this.activeGameData.gameBar = new GameBar(
      this.c_gameBar,
      floatingParent,
      this.activeGameData
    );
    this.activeGameData.clock = new ClockDisplay(
      this.c_gameBar,
      playerActivityUpdate,
      this.activeGameData
    );
    this.activeGameData.clock.start();
    if (this.activeGameData.playOnPortrait && this.activeGameData.isMobile) {
      this.activeGameData.betPopper = new BetPopper(
        this.c_mobilePortrait,
        this.activeGameData.betChangeFunction,
        this.activeGameData
      );
      this.activeGameData.betPopper.getParent().y = 1200;
      // console.log(this.activeGameData.betPopper.getParent().y)
    } else {
      this.activeGameData.betPopper = new BetPopper(
        this.activeGameData.gameScene,
        this.activeGameData.betChangeFunction,
        this.activeGameData
      );
    }

    // this.activeGameData.betPopper = new BetPopper(this.c_floatingBtn, onBetChangeUpDown, this.activeGameData);

    // this.activeGameData.betPopper.getParent().x=-0
    // this.activeGameData.betPopper.getParent().y=-1080
    this.activeGameData.betConfirmation = new PopupMessageBox(
      2,
      this.activeGameData.size,
      this.activeGameData
    );
    this.activeGameData.betConfirmation.setHeadText(
      this.activeGameData.gameTextGeneral.stakeChangeHead
    );
    this.activeGameData.betConfirmation.setLabel(
      0,
      this.activeGameData.gameTextGeneral.YES
    );
    this.activeGameData.betConfirmation.setLabel(
      1,
      this.activeGameData.gameTextGeneral.NO
    );
    this.activeGameData.betConfirmation.setButtons(
      0,
      betConfirm.bind(self, true, this.activeGameData)
    );
    this.activeGameData.betConfirmation.setButtons(
      1,
      betConfirm.bind(self, false, this.activeGameData)
    );
    this.activeGameData.betConfirmation.setMessageBoxVisibile(false);
    // this.activeGameData.betConfirmation.setChildOf(
    //   this.activeGameData.gameScene
    // );

    //-create AutoplayPopup====================================================
    if (this.activeGameData.isMobile) {
      this.activeGameData.autoplayPopper = new AutoplayPopper(
        this.activeGameData.gameBar.getMobileContainer(),
        onChangeAutoplay,
        this.activeGameData
      );
    } else {
      this.activeGameData.autoplayPopper = new AutoplayPopper(
        this.activeGameData.gameScene,
        onChangeAutoplay,
        this.activeGameData
      );
    }

    // this.activeGameData.autoplayPopper = new AutoplayPopper(this.activeGameData.gameScene, onChangeAutoplay, (this.activeGameData))
    //set Functions for poppers===================================================

    // this.activeGameData.gameBar.setAutoplayBtnFunction(
    //   setAutoPlay.bind(this, this.activeGameData)
    // );

    const { activeGameData } = this;
    this.activeGameData.gameBar.setAutoplayBtnFunction(() =>
      setAutoPlay(activeGameData)
    );

    this.activeGameData.gameBar.setBetBtnFunction(
      onBetChangeWindow.bind(undefined, this.activeGameData)
    );
    this.activeGameData.gameBar.setBetUpBtnFunction(
      this.activeGameData.betChangeFunction.bind(
        undefined,
        "up",
        this.activeGameData
      )
    );
    this.activeGameData.gameBar.setBetDownBtnFunction(
      this.activeGameData.betChangeFunction.bind(
        undefined,
        "down",
        this.activeGameData
      )
    );
    this.activeGameData.gameBar.setGambleBtnFunction(gambleClick);
    this.createLowBalMessage();

    // console.log(this.activeGameData.betSelected,"-----")
    this.activeGameData.gameBar.setBetValue(
      this.activeGameData.betSelected.getDisplayValue()
    );
    // this.activeGameData.balance = new Credits(data.playerBalance.creditsBalance.amount);

    this.activeGameData.gameBar.setBalValue(
      this.activeGameData.balance.getDisplayValue()
    );
    // console.log(this.activeGameData.balance)
    this.activeGameData.gameBar.setWinValue(0);
  };
  private createJackpot = (): void => {
    this.activeGameData.jackPotGame = new jackPotManager(
      this.c_JackpotGame,
      this.activeGameData
    );
  };

  private createTournament = (): void => {
    if (this.activeGameData.isTournament) {
      this.activeGameData.tournamentmode = new Tournament(
        this.c_tournament,
        this.activeGameData
      );
      // this.activeGameData.tournamentmode.autoUpdate()
    }
  };
  private createCoins = (): void => {
    if (this.activeGameData.isMobile) {
      this.activeGameData.jumpCoin = new JumpingCoins(
        this.c_coins,
        this.activeGameData.size,
        100
      );
    } else {
      this.activeGameData.jumpCoin = new JumpingCoins(
        this.c_coins,
        this.activeGameData.size,
        200
      );
    }
    this.activeGameData.soundList.push(
      this.activeGameData.jumpCoin.getCoinSound()
    );
  };
  private createGambleGame = (): void => {
    if (this.activeGameData.enableNewGambleGameFromNico === false) {
      //generic gamble game
      this.activeGameData.gambleGame = new GambleGame(
        this.activeGameData,
        this.c_gameScene
      );
    } else {
      //new gamble game system originally made for nico game
      this.activeGameData.gambleGame = new GambleGameNico(
        this.activeGameData,
        this.c_gameScene
      );
    }

    // this.activeGameData.gambleGame.placeTo(parent);
  };
  private recoverGame = (): void => {
    this.activeGameData.playable = false;
    // enableChangeBet(false, this.activeGameData)//disablebet
    this.activeGameData.serverAction = this.activeGameData.API_handler.getServerActionRecover(); // "RECOVER";
    var recoverData = { action: this.activeGameData.serverAction };
    this.activeGameData.displayReplayMsg = true;
    // this.activeGameData.API_handler.requestServer("game", recoverData, this.activeGameData.recoverSuccess, this.activeGameData.recoverFail)

    this.activeGameData.API_handler.GetGamePlayResult(
      recoverData,
      this.activeGameData.recoverSuccess,
      this.activeGameData.recoverFail
    );
  };
  private destroyLoadingScreenListner = (): void => {
    window.removeEventListener("resize", this.preloadProgressResize, false);
    this.preloadProgressResize = null;
    // console.log("disable")
  };
  // private RecoverFail = (): void => {
  //     this.callBackFailMessage(0);
  // };
  private loginFail = (errorType: string): void => {
    // console.log(  this.activeGameData.errorTypeToDisplay)
    this.activeGameData.errorTypeToDisplay = errorType;

    this.callBackFailMessage(6);
    throw new Error("Login failed!");
    // console.log("LOGIN ERROR", errorType)
  };
  private callBackFailMessage = (index: number): void => {
    //display error messages

    if (this.activeGameData.errorBox == undefined) {
      this.activeGameData.errorBox = new PopupMessageBox(
        0,
        this.activeGameData.size,
        this.activeGameData
      );
      this.activeGameData.errorBox.setHeadText("");
      // this.activeGameData.errorBox.setChildOf(this.activeGameData.gameScene);
    }
    // this.activeGameData.errorBox = new PopupMessageBox(0, this.activeGameData.size);
    // this.activeGameData.errorBox.setHeadText("");
    // this.activeGameData.errorBox.setChildOf(this.activeGameData.gameScene);
    this.activeGameData.errorBox.setMessageBoxPosY(1080 / 2 - 350 / 2); //messageBoxContainer.y = 1080 / 2 - 350 / 2;
    // this.activeGameData.errorBox.setMessageBoxVisibile(true);
    switch (index) {
      case 0: //recover Fail/--
        this.activeGameData.errorBox.setBodyText(
          this.activeGameData.gameTextGeneral.ErrorRecover
        );

        // this.activeGameData.errorBox.setBodyText(eval('this.activeGameData.gameTextGeneral.'+this.activeGameData.errorTypeToDisplay));
        this.setRescale(); //to display the error centered
        break;
      case 1: //Login Fail//--
        this.activeGameData.errorBox.setBodyText(
          this.activeGameData.gameTextGeneral.ErrorLogin
        );
        // this.activeGameData.errorBox.setBodyText(eval('this.activeGameData.gameTextGeneral.'+this.activeGameData.errorTypeToDisplay));

        this.setRescale(); //to display the error centered
        break;
      case 2: //BetFail //-
        // this.activeGameData.errorBox.setBodyText(eval('this.activeGameData.gameTextGeneral.'+this.activeGameData.errorTypeToDisplay));

        this.activeGameData.errorBox.setBodyText(
          this.activeGameData.gameTextGeneral.ErrorBet
        );
        this.setRescale(); //to display the error centered
        break;
      case 3: //collect Fail//-
        // this.activeGameData.errorBox.setBodyText(eval('this.activeGameData.gameTextGeneral.'+this.activeGameData.errorTypeToDisplay));

        this.activeGameData.errorBox.setBodyText(
          this.activeGameData.gameTextGeneral.ErrorCollect
        );
        this.setRescale(); //to display the error centered
        break;
      case 4: //Gamble fail//--
        // this.activeGameData.errorBox.setBodyText(eval('this.activeGameData.gameTextGeneral.'+this.activeGameData.errorTypeToDisplay));

        this.activeGameData.errorBox.setBodyText(
          this.activeGameData.gameTextGeneral.ErrorGamble
        );
        this.setRescale(); //to display the error centered
        break;
      case 5: //Network Error
        this.activeGameData.errorBox.setHeadText(
          this.activeGameData.gameTextGeneral.networkErrorTitel
        );
        this.activeGameData.errorBox.setBodyText(
          this.activeGameData.gameTextGeneral.networkErrorBody
        );
        this.setRescale(); //to display the error centered
        break;

      case 6:
        let checkError = undefined;
        if (typeof this.activeGameData.errorTypeToDisplay == "string") {
          this.activeGameData.errorTypeToDisplay = this.activeGameData.errorTypeToDisplay.replace(
            " ",
            ""
          ); //Remove space
          checkError = eval(
            "this.activeGameData.gameTextGeneral." +
              this.activeGameData.errorTypeToDisplay
          );
        }
        if (checkError === undefined) {
          this.activeGameData.errorTypeToDisplay = undefined;
        } //set the error msg to undefined to display generic error
        // this.activeGameData.errorBox.setBodyText(eval('this.activeGameData.gameTextGeneral.'+this.activeGameData.errorTypeToDisplay));
        if (this.activeGameData.errorTypeToDisplay == "INSUFFICIENT_FUNDS") {
          // if (this.activeGameData.errorTypeToDisplay == 'UNKNOWN') {
          this.activeGameData.infiniteSpin = false;
          this.activeGameData.mainGame.stopTicker();

          this.activeGameData.lowBalanceMessage.setHeadText(
            this.activeGameData.gameTextGeneral.noBalanceHead
          );
          this.activeGameData.lowBalanceMessage.setBodyText(
            this.activeGameData.gameTextGeneral.noBalanceBody
          ); //reset game

          this.activeGameData.mainGame.resetReels();
          if (this.activeGameData.isTournament == false) {
            this.activeGameData.requestNewBalance(this.activeGameData); //UPDATE THE BALANCE
          }
          this.activeGameData.requestNewBalance(this.activeGameData); //UPDATE THE BALANCE
          this.activeGameData.lowBalanceMessage.setMessageBoxVisibile(true, -1);
          // console.log('Display ErrorBox and reset Game to previosuststate');
        } else if (
          this.activeGameData.errorTypeToDisplay === undefined ||
          this.activeGameData.errorTypeToDisplay == ""
        ) {
          //fallback to unknow error
          this.activeGameData.errorBox.setBodyText(
            this.activeGameData.gameTextGeneral.UNKNOWN
          );
          this.activeGameData.errorBox.setMessageBoxVisibile(true, -1);
          this.displayErrorBtn();
        } else {
          this.displayErrorBtn(); //should be placed before opening the message box as the buttonmode is controlled by it
          let msgText = eval(
            "this.activeGameData.gameTextGeneral." +
              this.activeGameData.errorTypeToDisplay
          );
          this.activeGameData.errorBox.setMessageBoxVisibile(true, -1);
          this.activeGameData.errorBox.setBodyText(msgText);
        }

        this.setRescale(); //to display the error centered
        break;
    }
  };

  private displayErrorBtn = (): void => {
    this.activeGameData.errorBox.setBtns(
      1,
      [this.activeGameData.gameTextGeneral.CLOSE],
      [onOptionButtonDownRedirectHome]
    );
  };
  private createLowBalMessage = (): void => {
    // console.log("Low bal messageCreated")

    if (this.activeGameData.isTournament) {
      //disbale
      this.activeGameData.lowBalanceMessage = new PopupMessageBox(
        1,
        this.activeGameData.size,
        this.activeGameData
      );
      this.activeGameData.lowBalanceMessage.setHeadText(
        this.activeGameData.gameTextGeneral.networkErrorTitel
      );
      this.activeGameData.lowBalanceMessage.setBodyText(
        this.activeGameData.gameTextGeneral.networkErrorBody
      );
      // this.activeGameData.lowBalanceMessage.setChildOf(
      //   this.activeGameData.gameScene
      // );
      this.activeGameData.lowBalanceMessage.setMessageBoxVisibile(false);

      this.activeGameData.lowBalanceMessage.setLabel(
        0,
        this.activeGameData.gameTextGeneral.CLOSE
      );
      this.activeGameData.lowBalanceMessage.setButtons(
        0,
        lowBalConfirm.bind(self, this.activeGameData)
      );
      // this.activeGameData.lowBalanceMessage.setLabel(0, this.activeGameData.gameTextGeneral.DEPOSIT);
      // this.activeGameData.lowBalanceMessage.setButtons(0, depositURL.bind(self, this.activeGameData));
    } else {
      this.activeGameData.lowBalanceMessage = new PopupMessageBox(
        2,
        this.activeGameData.size,
        this.activeGameData
      );
      this.activeGameData.lowBalanceMessage.setHeadText(
        this.activeGameData.gameTextGeneral.networkErrorTitel
      );
      this.activeGameData.lowBalanceMessage.setBodyText(
        this.activeGameData.gameTextGeneral.networkErrorBody
      );
      // this.activeGameData.lowBalanceMessage.setChildOf(
      //   this.activeGameData.gameScene
      // );
      this.activeGameData.lowBalanceMessage.setMessageBoxVisibile(false);

      this.activeGameData.lowBalanceMessage.setLabel(
        1,
        this.activeGameData.gameTextGeneral.CLOSE
      );
      this.activeGameData.lowBalanceMessage.setButtons(
        1,
        lowBalConfirm.bind(self, this.activeGameData)
      );
      this.activeGameData.lowBalanceMessage.setLabel(
        0,
        this.activeGameData.gameTextGeneral.DEPOSIT
      );
      this.activeGameData.lowBalanceMessage.setButtons(
        0,
        depositURL.bind(self, this.activeGameData)
      );
    }
  };

  private portraitBGContainerAutoScale = (canvas: HTMLCanvasElement): void => {
    let newHeight = canvas.height;
    let newWidthScale = this.c_gameScene.scale.x; //scale the x axis to match the scaling with the gameElem
    this.portraitModeBackground.setNewHeight(newHeight);
    this.portraitModeBackground.setNewWidthScale(newWidthScale);
  };

  private scaleAdjustmenets() {
    this.c_bg.y = this.c_gameScene.y;

    let canvas = document.getElementsByTagName("canvas")[0];
    let sky = this.activeGameData.background.getImageBg();
    sky.width = canvas.width; //window.innerWidth / this.activeGameData.resolution;
    sky.height = canvas.height; //1080 //this.c_gameScene.height//window.innerHeight/resolution;
    //---update portrait bg to fix whole screeen
    this.portraitBGContainerAutoScale(canvas);
    if (this.activeGameData.jackPotGame) {
      this.activeGameData.jackPotGame.setJackpotBlackBGWidth(canvas.width);
    }
    //extra, used mostly for the apps and no games
    if (this.activeGameData.mainGame.onResize != undefined) {
      this.activeGameData.mainGame.onResize();
    }

    //
    this.activeGameData.gameOption.onResize();
    if (this.activeGameData.gambleGame != undefined) {
      this.activeGameData.gambleGame.onResize();
    }
    if (this.activeGameData.jackPotGame != undefined) {
      this.activeGameData.jackPotGame.onResize();
    }

    if (this.activeGameData.replay != undefined) {
      this.activeGameData.replay.onResize();
    }

    this.c_MASK.width = canvas.width;
    this.c_MASK.height = this.activeGameData.gameResolution[1];
    this.activeGameData.gameBar.setMobileBtnPosX(
      this.app.renderer.view.width -
        (this.activeGameData.gameBar.getMobileWidth() / 2) *
          (this.activeGameData.gameResolution[0] / 1920)
    );
    window.scrollTo(0, 0);
    if (this.activeGameData.playOnPortrait && this.activeGameData.isMobile) {
      this.activeGameData.jackPotGame.setPortraitPlacement(); //portrait or landscape mode resize and reposition on mobile
      if (this.activeGameData.isTournament) {
        this.activeGameData.tournamentmode.setPortraitPosition();
      }

      let screenRatio = window.innerHeight / window.innerWidth;
      let orientationPortrait = window.matchMedia("(orientation: portrait)")
        .matches;

      // console.log( "PORTRAIT: ",orientationPortrait,"RATIO: ", screenRatio , this.activeGameData.minRatioForPortraitPlay )
      if (
        orientationPortrait &&
        screenRatio >= this.activeGameData.minRatioForPortraitPlay
      ) {
        this.mobilePortraitBG.width = this.activeGameData.size[0];
        // let scaleMultiplier=this.activeGameData.size[1]/this.activeGameData.gameResolution[1];
        // scaleMultiplier
        let sss =
          this.activeGameData.gameResolution[1] / this.activeGameData.size[1];

        let offsetTop =
          (this.activeGameData.portraitPlayOffsetTop * window.innerWidth) /
          this.activeGameData.resolution /
          this.activeGameData.size[0];
        // this.mobilePortraitBG.height=Math.abs(canvas.height*scaleMultiplier-this.c_MASK.height*scaleMultiplier-offsetTop);//canvas.height-1080

        this.mobilePortraitBG.height = Math.abs(
          canvas.height / sss -
            this.c_MASK.height / sss -
            this.activeGameData.portraitPlayOffsetTop
        ); //canvas.height-1080

        this.mobilePortraitBG.alpha = 0.0;
        this.activeGameData.gameBar.setMobileBtnPosX(0);
        this.activeGameData.gameBar.setMobileBtnPosY(
          this.c_MASK.height + offsetTop
        );
        // this.mobilePortraitBG.y=
        this.activeGameData.gameBar.setPortraitPlay();

        // console.log('HERE')
        this.activeGameData.mobilePortraitUI.setVisible(true);

        this.activeGameData.setGameElementsPortraits(false);
        // this.updateGrameRoundOrientationToLandScape(false);
        this.setEmulationOrientationLandScape(false);
        this.activeGameData.minimumStakePopup.setPortraitMode();

        //--game name
        this.activeGameData.miniBlackBarLandscape.setInPortraitMode();
        //-------check orientation for the bonus win msg

        let mP_UI = this.activeGameData.mobilePortraitUI.getParent();
        mP_UI.y =
          -this.activeGameData.portraitPlayOffsetTop +
          canvas.height / sss -
          mP_UI.height +
          35; //(canvas.height/2)//-mP_UI.height+this.activeGameData.portraitPlayOffsetTop;
        // console.log("PORTRAIT MODE")
        // console.log(canvas.height,mP_UI.y,sss)
        if (this.activeGameData.BuyBonus != undefined) {
          this.activeGameData.BuyBonus.setPotraitMode(true);
        }

        //--
        this.c_gameNameWaterMarkPortrait.y = this.activeGameData.portraitModeBackground.getBotContainer().y;
      } else {
        if (this.mobilePortraitBG.alpha == 1) {
          this.mobilePortraitBG.alpha = 0;
        }
        this.activeGameData.mobilePortraitUI.setVisible(false);
        // console.log("LANDSCAPE MODE")
        this.activeGameData.setGameElementsPortraits(true);
        // this.updateGrameRoundOrientationToLandScape(true);
        this.setEmulationOrientationLandScape(true);
        this.activeGameData.minimumStakePopup.setLandScapeMode();

        //--game name
        this.activeGameData.miniBlackBarLandscape.setInLandscapeMode();

        // if( this.splashBonusResult!=undefined)
        // {
        // this.splashBonusResult.setPortraitMode(false);
        // }
        this.activeGameData.gameBar.setPortraitPlay();

        if (this.activeGameData.BuyBonus != undefined) {
          this.activeGameData.BuyBonus.setPotraitMode(false);
        }
      }

      //-------------------TournamentResize handle
      if (this.activeGameData.isTournament) {
        this.activeGameData.tournamentmode.onResize();
      }
      //------------------resize logo
      if (
        this.activeGameData.isMobile &&
        this.activeGameData.logo != undefined
      ) {
        this.activeGameData.logo.onResize();
      }
    } else {
      this.activeGameData.setGameElementsPortraits(true);
      // this.updateGrameRoundOrientationToLandScape(true);
      this.setEmulationOrientationLandScape(true);
      this.activeGameData.minimumStakePopup.setLandScapeMode();

      //--game name
      this.activeGameData.miniBlackBarLandscape.setInLandscapeMode();
    }

    if (this.activeGameData.blackScreen != undefined) {
      this.activeGameData.blackScreen.onResize();
    }
    if (this.activeGameData.blackScreen2 != undefined) {
      this.activeGameData.blackScreen2.onResize();
    }
    if (this.activeGameData.blackScreen_buyIn != undefined) {
      this.activeGameData.blackScreen_buyIn.onResize();
    }
  }
  private checkResulationForDynamicScaling = (): void => {
    setDynamicRenderResolution(this.activeGameData);
  };
  private setRescale = (): void => {
    if (
      !this.activeGameData.gameOption ||
      !this.activeGameData.gameOption.getHDIsOn
    ) {
      return; //do not rescale if the gameOption is not set
    }
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    this.activeGameData.isInPortraitMode = orientationPortrait;

    this.checkResulationForDynamicScaling();

    for (let i = 0; i < this.c_all.length; i++) {
      autoRescale(this.c_all[i], this.activeGameData, this.app);
    }

    // if (
    //   getParameterByName("mobile") == "true" &&
    //   this.mobileGuideDisplay != undefined
    // ) {
    //   this.mobileGuideDisplay.setResize();
    //   ////-*-
    //   // dd
    // }
    this.scaleAdjustmenets();
    // if (this.activeGameData.isIphone) {
    //   this.mobileGuideDisplay.iphoneScreenSizeCheckWithDelay();
    // }

    pauzeAutoPlayOnOrientationChange(this.activeGameData);

    let enableDebugger = false;
    if (enableDebugger) {
      this.debuggerScreen.updateSize();

      setTimeout(
        function() {
          this.debuggerScreen.updateSize();
        }.bind(this),
        500
      );
    }
    this.activeGameData.checkCanPlayOnPortrait();
  };
  private setEmulationOrientationLandScape = (bool: boolean): void => {
    if (
      this.activeGameData.isEmulation &&
      this.activeGameData.emulationMode != undefined
    ) {
      this.activeGameData.emulationMode.setLandScapeMode(bool);
    }
  };
  // private updateGrameRoundOrientationToLandScape = (bool: boolean): void => {
  //   if (this.activeGameData.gameRoundDisplayOverlay != undefined) {
  //     this.activeGameData.gameRoundDisplayOverlay.setIsLandScape(bool);
  //   }
  // };

  public setErrorMessage = (index: number): void => {
    this.callBackFailMessage(index);
  };

  private setFreeSpins = (): void => {
    this.activeGameData.freeSpinMode = new FreespinMode(
      this.c_gameScene,
      this.activeGameData
    );
  };
  public setGameContainer = (container: PIXI.Container): void => {
    this.gameContainer = container;
    this.app.stage.addChild(this.gameContainer);
  };
  public setOptionPage = (totalPages: number): void => {
    //create option with given number of pages , the last one is by default  settings
    this.activeGameData.gameOption = new OptionBuilder(
      this.c_option,
      this.activeGameData,
      totalPages
    );
    this.activeGameData.gameOption.setDesktopHeight(730);
    this.activeGameData.gameOption.setDesktopWidth(1250); //(1175);
  };
  public setMainGame = (
    mainGame: IGameElement<T>,
    parentC: PIXI.Container = this.c_gameScene
  ) => {
    //create

    this.activeGameData.gameScene = parentC;
    try {
      this.activeGameData.mainGame = new mainGame(
        this.activeGameData as T,
        this.c_gameScene
      );
    } catch (err) {
      console.warn("ERROR___________________", err);
      Sentry.captureException(err);
      this.loginFail("Failed to create main game");
    }

    if (this.activeGameData.isMobile) {
      //can be removed (!need to fix the position of autoplay sticky to bot first)

      this.mobilePortraitBG = new PIXI.Sprite(
        PIXI.Texture.fromFrame("btn_Play.png")
      );
      this.mobilePortraitBG.width = 0;
      this.mobilePortraitBG.height = 0;
      // this.mobilePortraitBG.rotation=90*(Math.PI/180)
      // this.c_floatingBtn.addChild( this.mobilePortraitBG)

      this.activeGameData.mobilePortraitUI = new PortraitMode(
        this.c_mobilePortrait,
        this.activeGameData
      );

      this.activeGameData.mobilePortraitBG = this.mobilePortraitBG;
    }

    this.createMenuBar(this.c_floatingBtn, playerActivityUpdate); //create a game and the floating bar

    this.c_gameScene.addChild(this.c_logoContainer);
    this.createGambleGame(); //create gamble game
  };
  public setSky(imgName: string) {
    // this.activeGameData.background = new backgroundsky(this.c_bg, imgName);
    this.activeGameData.background.setNewTexture(imgName);
    this.activeGameData.portraitBGSky = new PIXI.Sprite(
      PIXI.Texture.fromFrame(imgName)
    );
    this.activeGameData.portraitModeBackground
      .getFillContainer()
      .addChild(this.activeGameData.portraitBGSky);
  }
  public setEnvironment(env: IGameElement<T>) {
    this.activeGameData.environment = new env(
      this.activeGameData as T,
      this.c_env
    );
  }
  private setMask() {
    this.c_MASK = new PIXI.Graphics(); //mask to clip out anythings that goes out of play-area
    this.c_MASK.beginFill(0xffff00, 0);
    this.c_MASK.drawRect(0, 0, this.c_bg.width, this.c_bg.height);
    this.c_MASK.endFill();
    this.c_MASK.alpha = 1;
    this.activeGameData.mainMaskContainer = this.c_bg;
    // this.c_gameScene.addChild(this.c_MASK)

    this.c_bg.addChild(this.c_MASK);
    this.activeGameData.gameSceneMask = this.c_MASK;
    this.c_bg.mask = this.c_MASK;
    this.c_env.mask = this.c_MASK;
    this.c_bonusOverMessageContainer.mask = this.c_MASK;
    if (this.activeGameData.isMobile == false) {
      this.c_coins.mask = this.c_MASK;
      this.c_bonusBuy.mask = this.c_MASK;
    }

    this.c_gameScene.mask = this.c_MASK;
    this.overlayBonusContainer.mask = this.c_MASK;
    this.c_gameNameWaterMarkLandScape.mask = this.c_MASK;
  }
  //---------------------------GETTERS

  public getGameContainer = (): PIXI.Container => {
    return this.gameContainer;
  };
  public getGameScene = (): PIXI.Container => {
    return this.c_gameScene;
  };
  public getLanguage = (): string => {
    return this.lang;
  };
  public getApp = (): PIXI.Application => {
    return this.app;
  };

  public setLogo = (
    logoName: string,
    enableSmallLogoMobile: boolean,
    displayFrame: boolean = true
  ): void => {
    this.activeGameData.logo = new logoOverlay(
      this.c_logoContainer,
      logoName,
      this.activeGameData,
      enableSmallLogoMobile,
      displayFrame
    );
  };

  public getlogoBG = (): PIXI.Sprite => {
    let sprite = this.activeGameData.logo.getLogoBG();
    return sprite;
  };
  public getLogo = (): logoOverlay => {
    return this.activeGameData.logo;
  };

  getClock = (): ClockDisplay => {
    return this.activeGameData.clock;
  };
}
